import { Route, Routes } from "react-router-dom";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import "./App.css";
import Avatar from "./components/Avatar";
import BackToTop from "./components/BackToTop";
import Navbar from "./components/Navbar";
import Home from "./pages/Home/Home";
import ProjectDetails from "./pages/ProjectDetails.js/ProjectDetails";

function App() {
  return (
    <div className="App">
      <div className="main-wrapper">
        <Avatar />
        <div className="routes">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/project/:projectId" element={<ProjectDetails />} />
          </Routes>
        </div>
        <Navbar/>
        <BackToTop/>
      </div>
    </div>
  );
}

export default App;
